import React, { FC } from "react";
import { InputLabel as MuiInputLabel } from "@mui/material";

type Props = React.ComponentProps<typeof MuiInputLabel>;

const InputLabel: FC<Props> = (props) => {
    return <MuiInputLabel {...props}/>
}

export default InputLabel;